<template>
  <div class="dm">
    <div class="dm-sidebar">
      <SearchFormLocation
        :foundDealers.sync="foundDealers"
        :apiUrl="apiUrl"
        :apiKey="apiKey"
        :culture="culture"
        :numberOfResults="numberOfResults"
        :selectedCategories="selectedCategories"
        :mapOptions.sync="mapOptions"
        :homePosition.sync="homePosition"
        :translations="translations"
      >
        <template #searchButton="searchButton"
          ><slot
            name="searchButton"
            :search="searchButton.search"
            :localSearchTerm="searchButton.localSearchTerm"
          ></slot
        ></template>
      </SearchFormLocation>
      <Filters
        :allCategories="allCategories"
        :selectedCategories.sync="selectedCategories"
        :assetsFolder="assetsFolder"
        :translations="translations"
        :showFilters="showFilters"
      >
        <template #filterButton="filterButton"
          ><slot
            name="filterButton"
            :toggleFilters="filterButton.toggleFilters"
            :translations="filterButton.translations"
          ></slot></template
        ><template #filterItem="filterItem"
          ><slot
            name="filterItem"
            :allCategories="filterItem.allCategories"
            :changeFilter="filterItem.changeFilter"
            :selectedFilters="filterItem.selectedFilters"
            :getMarker="filterItem.getMarker"
            :openTooltip="filterItem.openTooltip"
            :toggleTooltip="filterItem.toggleTooltip"
          ></slot></template
        ><template #filterPostText="filterPostText"
          ><slot
            name="filterPostText"
            :translations="filterPostText.translations"
          ></slot></template
      ></Filters>
      <Results
        :activeDealer.sync="activeDealer"
        :foundDealers="foundDealers.length ? foundDealers : allDealers"
        :mapOptions.sync="mapOptions"
        :assetsFolder="assetsFolder"
        :translations="translations"
        ><template #results="results"
          ><slot
            name="results"
            :foundDealers="results.foundDealers"
            :selectDealer="results.selectDealer"
            :getMarker="results.getMarker"
            :translations="results.translations"
          >
          </slot></template
      ></Results>
      <ResultOverlay
        :activeDealer.sync="activeDealer"
        v-if="activeDealer !== null"
        :translations="translations"
        ><template #resultOverlay="resultOverlay"
          ><slot
            name="resultOverlay"
            :clearActiveDealer="resultOverlay.clearActiveDealer"
            :getWebsite="resultOverlay.getWebsite"
            :activeDealer="resultOverlay.activeDealer"
            :translations="resultOverlay.translations"
            :getCategoryCodeName="resultOverlay.getCategoryCodeName"
            :getCategoryDisplayName="resultOverlay.getCategoryDisplayName"
          ></slot></template
      ></ResultOverlay>
    </div>
    <Map
      :allDealers="foundDealers.length ? foundDealers : allDealers"
      :activeDealer.sync="activeDealer"
      :foundDealers="foundDealers"
      :mapOptions.sync="mapOptions"
      :assetsFolder="assetsFolder"
      :homePosition.sync="homePosition"
      :defaultCountry="defaultCountry"
      :clusterTextColor="clusterTextColor"
    />
  </div>
</template>

<script>
import SearchFormLocation from '../package/components/SearchFormLocation.vue';
import Filters from '../package/components/Filters.vue';
import Results from '../package/components/Results.vue';
import ResultOverlay from '../package/components/ResultOverlay.vue';
import Map from '../package/components/Map.vue';

import DealerModuleProvider from '../package/providers/DealerModuleProvider.js';
import TranslationsProvider from '../package/providers/TranslationsProvider.js';
import Translations from '../package/models/translations.model.js';

export default {
  name: 'DealerModule',
  components: {
    SearchFormLocation,
    Filters,
    Results,
    ResultOverlay,
    // eslint-disable-next-line
    Map
  },
  props: {
    assetsFolder: String,
    apiUrl: String,
    apiKey: String,
    translationsUrl: String,
    numberOfResults: String,
    culture: String,
    defaultCountry: String,
    showFilters: {
      type: Boolean,
      default: false
    },
    clusterTextColor: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      allDealers: [],
      foundDealers: [],
      homePosition: {},
      activeDealer: null,
      allCategories: [],
      selectedCategories: [],
      mapOptions: {
        zoom: 10,
        position: { lat: 52.092876, lng: 5.10448 }
      },
      errorMessage: '',
      loading: false,
      translations: {}
    };
  },
  mounted() {
    this.getAllDealers();
    var dealerModuleProvider = new DealerModuleProvider({
      apiUrl: this.apiUrl,
      culture: this.culture
    });
    var translationsProvider = new TranslationsProvider({
      translationsUrl: this.translationsUrl
    });
    dealerModuleProvider
      .getCategories()
      .then((response) => {
        var parsedResults = JSON.parse(response);
        var results = parsedResults.value;
        this.allCategories = results;
      })
      .catch((error) => {
        this.errorMessage = 'Unable to load dealers' + error;
        this.loading = false;
      });
    translationsProvider
      .getAllTranslations()
      .then((response) => {
        this.translations = new Translations(JSON.parse(response));
      })
      .catch(() => {
        this.translations = new Translations();
      });
  },
  methods: {
    getAllDealers() {
      var dealerModuleProvider = new DealerModuleProvider({
        apiUrl: this.apiUrl,
        culture: this.culture
      });
      dealerModuleProvider
        .getAllDealers(this.selectedCategories)
        .then((response) => {
          var parsedResults = JSON.parse(response);
          var results = parsedResults.value;
          this.allDealers = results;
        })
        .catch((error) => {
          this.errorMessage = 'Unable to load dealers' + error;
          this.loading = false;
        });
    }
  },
  watch: {
    selectedCategories() {
      this.getAllDealers();
    }
  }
};
</script>

<style lang="scss">
.dm {
  display: flex;
  align-items: stretch;
  height: 100vh;

  @media (max-width: 991.98px) {
    height: auto;
    flex-direction: column;
  }
}
.dm-sidebar {
  flex: 0 0 420px;
  height: 100%;
  background-color: #f6f6f6;
  display: flex;
  flex-direction: column;
  border: 1px solid #dddddd;
  border-right: 1px solid #f6f6f6;
  flex-wrap: nowrap;
  width: 100%;
  align-items: stretch;
  position: relative;
}
</style>

